import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LoaderModule } from '®shared/loader';

import { ListModeResolverComponent } from './list-mode-resolver.component';

@NgModule({
  imports: [CommonModule, LoaderModule, RouterModule],
  declarations: [ListModeResolverComponent],
  exports: [ListModeResolverComponent],
})
export class ListModeResolverModule {}
